// ui/mobileSubmit.ts — mobile top-bar "Submit Today's Run" shortcut.
//
// Extracted verbatim from an inline <script> in index.html.

export {};

/* ---------------------------------------------------------------------------
 * Mobile top-bar "Submit Today's Run" shortcut.
 * The form itself stays in the bottom sheet — duplicating it would mean
 * duplicate #handle / #btn-submit / #submit-result IDs and client.js would
 * only ever bind to the first one. So the header button opens the sheet and
 * scrolls the existing section into view instead.
 * ------------------------------------------------------------------------ */
(function () {
  var btn   = document.getElementById('btn-submit-top');
  var strip = document.getElementById('mobile-strip');
  var sec   = document.getElementById('submit-section');
  if (!btn || !sec) return;

  btn.addEventListener('click', function () {
    if (!document.body.classList.contains('sheet-expanded')) {
      /* Go through the strip's own handler first so whatever state client.js
       * keeps for the sheet stays in sync; the class is a fallback in case
       * that handler doesn't respond to a synthetic click. */
      if (strip) strip.click();
      document.body.classList.add('sheet-expanded');
    }
    /* Let the 0.22s sheet transition finish before scrolling. */
    setTimeout(function () {
      sec.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }, 240);
  });
})();
